

<div class="order" >

    <mat-card class="card-separator-line">
        <mat-card-title> {{ appService.convertirFecha(order.sourceCreationTime!) }} </mat-card-title>
    </mat-card>

    <mat-card class="card-simple-shadow" (click)="goToOrderDetail(order!)" >

        <mat-card-header>
            <mat-card-title [ngClass]="orderStatus.isDelivered ? 'text-sucess' : (orderStatus.isNotDelivered ? 'text-danger' : 'text-blue-puppis')"> {{ orderStatus.statusName }} </mat-card-title>
            <mat-card-subtitle class="subtitle-main" > Compraste en: {{ orderStatus.source }} </mat-card-subtitle>
            <mat-card-subtitle *ngIf="order!.sourceCode"> Orden: {{ order!.sourceCode }} </mat-card-subtitle>
          
            <div *ngIf="order!.fidelidadOrderPoints" id="order-header-right">
              <div class="order-points"> 
                <span class="title-puntos">{{order!.fidelidadOrderPoints.puntos}}</span>
                <span class="sub-title-puntos">Puntos por compra</span>
              </div>
              <div class="order-points"> 
                <span class="title-puntos">{{order!.fidelidadOrderPoints.fecha}}</span>
                <span class="sub-title-puntos">Fecha de vencimiento</span>
              </div>
            </div>
        
        </mat-card-header>

        <mat-card-content class="card-order-item" *ngFor="let orIt of order!.orderItems">
            <div class="card-order-content" >
              <div class="card-order-content-left">
                <img mat-card-sm-image [src]="orIt.imageUrl || getImageDefault()" (error)="loadErrorImage($event)" >
              </div>
              <div class="card-order-content-right">
                <mat-card-title> {{ orIt.description }} </mat-card-title>
                <mat-card-subtitle> Cantidad {{ orIt.quantity }} u. </mat-card-subtitle>
              </div>
            </div>
        </mat-card-content>
        <mat-card-actions align="end">
          <button mat-button>Detalle</button>
        </mat-card-actions>
    </mat-card>    
</div>
